import { render, staticRenderFns } from "./dataDirectory.vue?vue&type=template&id=7b645942&scoped=true"
import script from "./dataDirectory.vue?vue&type=script&lang=js"
export * from "./dataDirectory.vue?vue&type=script&lang=js"
import style0 from "./dataDirectory.vue?vue&type=style&index=0&id=7b645942&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b645942",
  null
  
)

export default component.exports